import React from 'react';
import { Button, Dialog, Grow, IconButton } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import PersonRemoveRoundedIcon from '@mui/icons-material/PersonRemoveRounded';
import '../Modal/modal.scss';
import './index.scss';

const SmoothGrow = React.forwardRef(function SmoothGrow(props, ref) {
  return <Grow ref={ref} timeout={{ enter: 320, exit: 200 }} {...props} />;
});

const RemoveUserFromProject = ({ open, handleClose, handleConfirmRemove, userName }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="remove-user-dialog-title"
      aria-describedby="remove-user-dialog-description"
      maxWidth="xs"
      fullWidth
      TransitionComponent={SmoothGrow}
      PaperProps={{ className: 'pj-modal pj-modal--danger' }}
      slotProps={{ backdrop: { className: 'pj-modal-backdrop' } }}
    >
      <div className="pj-modal-body">
        <IconButton className="pj-modal-close" size="small" onClick={handleClose} aria-label="Close">
          <CloseRoundedIcon fontSize="small" />
        </IconButton>

        <span className="pj-modal-badge">
          <PersonRemoveRoundedIcon />
        </span>

        <h3 className="pj-modal-title" id="remove-user-dialog-title">
          Remove {userName}?
        </h3>
        <p className="pj-modal-sub" id="remove-user-dialog-description">
          {userName} won&apos;t be able to work on this project anymore. You can
          add them back later.
        </p>
      </div>

      <div className="pj-modal-actions">
        <Button className="pj-btn pj-btn--quiet" onClick={handleClose}>
          Cancel
        </Button>
        <Button className="pj-btn pj-btn--primary" onClick={handleConfirmRemove} autoFocus>
          Yes, remove
        </Button>
      </div>
    </Dialog>
  );
};

export default RemoveUserFromProject;
